import { request } from '../client';

// Stateless — recomputes authoritative pricing server-side. Does not reserve
// stock; stock is only reserved at order placement (see endpoints/orders.js).
//
// Sends only what the customer asked for ({ productId, quantity } per line,
// and the coupon code they submitted, if any); prices, offers, coupon
// eligibility, charges and the outlet are all the backend's to decide, from the
// X-Delivery-* geography the client attaches. `includeAvailableCoupons` asks
// the backend to list the listed codes this basket could use (suggestions
// only). geographySensitive rejects a quote that arrives after the browsing
// location changed. Remaining `options` pass through to request(), e.g. a
// pinned `deliveryGeography` for a checkout address (a pinned request is never
// stale).
export const quoteCart = (items, { couponCode = null, includeAvailableCoupons = false, ...options } = {}) =>
  request('/cart/quote', {
    geographySensitive: true,
    ...options,
    method: 'POST',
    body: {
      items,
      fulfillmentMode: 'allow_split',
      ...(couponCode ? { couponCode } : {}),
      ...(includeAvailableCoupons ? { includeAvailableCoupons: true } : {}),
    },
  });
